const GOODIES = [];

export default GOODIES;
